import React from 'react';
import { fetchEnvActivities } from '../../app-main/actions/env';
import { get } from 'lodash';
import { BookingStatus, GetStatus } from '../booking-status';
import { InboxHeader } from '../InboxHeader';
import { BookingSummary } from '../../elements-summaries/booking-summary/BookingSummary';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { Helpers } from 'shared-components/helpers/helpers';
import ChatRenderer from './chat-renderer';
import ScrollContainer from './scroll-container';

class MessageInbox extends React.Component {

  componentDidMount () {
    this.originalHeight = document.body.style.height;
    document.body.style.height = 'auto';
    this.props.dispatch(fetchEnvActivities());
  }

  componentWillUnmount () {
    document.body.style.height = this.originalHeight;
  }

  render () {
    const {
      appProps,
      details,
      thread,
      name,
      responsiveness,
      getFullMessage,
      spinner,
      actionFn,
      actionCb,
      bundleUpdateRequest,
      msgError,
      contractData,
      accessToken,
      profile,
      generateMessageMetadata,
      env,
      reviewCb,
      context,
      guestCanUpdate,
      hostCanUpdate,
      hasNoContracts,
      pendingContracts,
      canInstantBook,
      updatedDetails,
      cancelUpdateDetails,
      dispatch,
      intl,
      inviteCreated
    } = this.props;

    const { previousLocation } = appProps;
    const {
      pathname,
      query
    } = previousLocation;
    const isBookingsPage = pathname && -1 !== pathname.indexOf('bookings');
    const inboxHeaderSettings = {
      backBtn: {
        title: isBookingsPage
          ? this.props.intl.formatMessage({
            id: 'inbox.message_inbox.bookings',
            defaultMessage: 'Bookings'
          })
          : this.props.intl.formatMessage({
            id: 'inbox.message_inbox.inbox',
            defaultMessage: 'Inbox'
          }),
        to: {
          pathname: isBookingsPage ? '/bookings' : '/inbox',
          query
        }
      },
      forwardBtn: {
        title: this.props.intl.formatMessage({
          id: 'inbox.message_inbox.details',
          defaultMessage: 'Details'
        }),
        to: {
          pathname: `/inbox/${details.booking_id}`,
          query: { page: 'details' }
        }
      },
      responsiveView: true,
      bundleUpdateRequest
    };

    const redirectGuestOnReviewSuccess = get(intl, 'locale', '')
      .includes(
        'en-'
      );

    const bookingStatus = GetStatus({
      details,
      user: appProps.profile,
      name,
      bundleUpdateRequest,
      reviewCb,
      redirectOnReviewSuccess: redirectGuestOnReviewSuccess,
      guestCanUpdate,
      hostCanUpdate,
      hasNoContracts,
      updatedDetails,
      canInstantBook,
      cancelUpdateDetails,
      accessToken,
      dispatch,
      contractData,
      inviteCreated
    }, context);

    return (
      <>
        <div
          className="message-main-web inbox-page-container"
          style={{
            borderColor: Helpers.pickColor(bookingStatus.borderColor)
          }}
        >
          <div className="ps-row inbox-layout-container">
            <div className="col-xs-12 col-lg-8 col-xl-9 booking-status-chat-container">
              <BookingStatus
                details={details}
                user={appProps.profile}
                name={name}
                bundleUpdateRequest={bundleUpdateRequest}
                reviewCb={reviewCb}
                redirectOnReviewSuccess={redirectGuestOnReviewSuccess}
                context={context}
                guestCanUpdate={guestCanUpdate}
                hostCanUpdate={hostCanUpdate}
                hasNoContracts={hasNoContracts}
                updatedDetails={updatedDetails}
                canInstantBook={canInstantBook}
                cancelUpdateDetails={cancelUpdateDetails}
                accessToken={accessToken}
                dispatch={dispatch}
                contractData={contractData}
                inviteCreated={inviteCreated}
              >
                <InboxHeader {...inboxHeaderSettings} />
              </BookingStatus>
              <div className="inbox-chat-container">
                <ChatRenderer
                  details={this.props.details}
                  thread={thread}
                  name={name}
                  responsiveness={responsiveness}
                  getFullMessage={getFullMessage}
                  spinner={spinner}
                  actionFn={actionFn}
                  actionCb={actionCb}
                  msgError={msgError}
                  contractData={contractData}
                  accessToken={accessToken}
                  profile={profile}
                  generateMessageMetadata={generateMessageMetadata}
                  env={env}
                  bundleUpdateRequest={bundleUpdateRequest}
                  intl={this.props.intl}
                />
              </div>
            </div>
            <div className="col-xs-12 col-lg-4 col-xl-3 d-xs-none d-lg-block booking-summary-container">
              <ScrollContainer>
                {bookingStatus.nextSteps && (
                  <div
                    className={'margin-lg-bottom margin-lg-left d-xs-none d-lg-block'}
                    data-testing-id="next-steps"
                  >
                    {bookingStatus.nextSteps}
                  </div>
                )}
                <div className="booking-summary-outline">
                  <BookingSummary
                    booking={details}
                    currentContracts={contractData}
                    pendingContracts={pendingContracts}
                    profile={profile}
                    intl={intl}
                    imgMargins={0}
                    imgContainerStyle={{
                      marginBottom: '24px',
                      borderRadius: '8px',
                      overflow: 'hidden'
                    }}
                    style={{
                      backgroundColor: 'white',
                      borderColor: 'transparent',
                      borderRadius: 0,
                      marginBottom: 0
                    }}
                  />
                </div>
              </ScrollContainer>
            </div>
          </div>
        </div>
      </>
    );
  }
}

MessageInbox.propTypes = {
  appProps: PropTypes.object,
  msgError: PropTypes.string,
  details: PropTypes.object,
  thread: PropTypes.object,
  name: PropTypes.string,
  getFullMessage: PropTypes.func,
  spinner: PropTypes.bool,
  actionFn: PropTypes.func,
  actionCb: PropTypes.func,
  responsiveness: PropTypes.object,
  bundleUpdateRequest: PropTypes.func,
  reviewCb: PropTypes.func,
  context: PropTypes.object,
  guestCanUpdate: PropTypes.bool,
  hostCanUpdate: PropTypes.bool,
  hasNoContracts: PropTypes.bool,
  cancelUpdateDetails: PropTypes.object,
  contractData: PropTypes.array,
  pendingContracts: PropTypes.array,
  accessToken: PropTypes.string,
  updatedDetails: PropTypes.object,
  canInstantBook: PropTypes.bool,
  dispatch: PropTypes.func,
  profile: PropTypes.object,
  inviteCreated: PropTypes.bool,
  generateMessageMetadata: PropTypes.func,
  env: PropTypes.object,
  intl: intlShape
};

exports.MessageInbox = injectIntl(MessageInbox);
